<template>
	<div class="form-container">
		<!-- PRODUCT DETAIL -->
		<CRow>
			<CCol lg="12">
				<h4 class="mb-4">
					Bundle
				</h4>
			</CCol>
		</CRow>

		<StoreFrontVisibility
			id="product-detail-visibility"
			:is-visible="formData.isProductDetailVisible"
			label="Product detail"
			image-url="/assets/images/promotion-step-4-product-detail.svg"
			image-alt="Promotion product detail"
			description="This location is a detail page of product that customer use to inspect and buy the product"
			@onChecked="handleProductDetailVisible"
		/>

		<CRow>
			<CCol md="6">
				<CInput
					v-model.trim="formData.titleEN"
					:is-valid="!$v.formData.titleEN.$error && null"
					:invalid-feedback="$t('global.error.required')"
					placeholder="Type title name (EN)"
					label="Title name (EN)*"
				/>
			</CCol>
			<CCol md="6">
				<CInput
					v-model.trim="formData.titleTH"
					:is-valid="!$v.formData.titleTH.$error && null"
					:invalid-feedback="$t('global.error.required')"
					placeholder="Type title name (TH)"
					label="Title name (TH)*"
				/>
			</CCol>
		</CRow>

		<CRow>
			<CCol md="6">
				<CInput
					v-model.trim="formData.subTitleEN"
					:is-valid="!$v.formData.subTitleEN.$error && null"
					:invalid-feedback="$t('global.error.required')"
					description="Type sub-title name (EN)"
					label="Sub-title name (EN)*"
				/>
			</CCol>
			<CCol md="6">
				<CInput
					v-model.trim="formData.subTitleTH"
					:is-valid="!$v.formData.subTitleTH.$error && null"
					:invalid-feedback="$t('global.error.required')"
					description="Type sub-title name (TH)"
					label="Sub-title name (TH)*"
				/>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import StoreFrontVisibility from '@/components/StoreFrontVisibility.vue';

import { PROMOTION_TYPES } from '../enums/promotions';

export default {
	name: 'PromotionDappStepDisplaying',
	components: {
		StoreFrontVisibility,
	},
	validations() {
		return {
			formData: {
				titleEN: {
					required,
				},
				titleTH: {
					required,
				},
				subTitleEN: {
					required,
				},
				subTitleTH: {
					required,
				},
			},
		};
	},

	mixins: [validationMixin],
	props: {
		defaultData: {
			type: Object,
			default: null,
		},
		promotionType: {
			type: String,
			default: PROMOTION_TYPES.GENERAL,
		},
		isEditMode: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		const {
			isProductDetailVisible = true,
			titleEN = '',
			titleTH = '',
			subTitleEN = '',
			subTitleTH = '',
		} = this.defaultData || {};
		return {
			formData: {
				isProductDetailVisible,
				titleEN,
				titleTH,
				subTitleEN,
				subTitleTH,
			},
		};
	},
	watch: {
		formData: {
			deep: true,
			handler(data) {
				this.$emit('update:is-valid', {
					valid: !this.$v.$invalid,
					data,
				});
			},
		},
	},
	methods: {
		handleProductDetailVisible(value) {
			this.formData.isProductDetailVisible = value;
		},
	},
};
</script>

<style lang="scss" scoped>
.form-container {
	margin-top: rem(80);
}
</style>
